import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"

import FetchFolderGateway from "../../../gateway/Folder/FetchFolderGateway"
import Loader from '../loader/Loader'
import { FolderDetail } from "../../../domain/Folder/Folder"
import { useQuery } from '../../../infrastructure/hooks'
import FormGateway from "../../../gateway/Form/FormGateway"
import Forms from "../../../domain/Form/Forms"
import FoldersDataList from "./FoldersDataList"
import { ListAppearance } from "../button/AppearanceDropDown"

interface Props {
  term: string,
  formId: string | null
  viewMode: ListAppearance
}

const ITEMS_PER_PAGE = 10;

const PreSignatureValidationFoldersComponent = ({ term, formId, viewMode }: Props): JSX.Element => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [folders, setFolders] = useState<FolderDetail[] | null>(null);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [forms, setForms] = useState<Forms[]>([])

  const query = useQuery();
  const history = useHistory();
  const currentPage = query.get('currentPage') || '1';
  const currentPageNumber = parseInt(currentPage, 10);
  const [sortConfig, setSortConfig] = useState<{ key: string, direction: 'asc' | 'desc' }>({
    key: 'date',
    direction: 'desc'
  });

  const updateQueryParams = (params: { [key: string]: string }) => {
    const searchParams = new URLSearchParams(query);
    Object.keys(params).forEach(key => searchParams.set(key, params[key]));
    history.push({ search: searchParams.toString() });
  };

  const requestSort = (key: string) => {
    let direction: 'asc' | 'desc' = 'asc';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  useEffect(() => {
    const fetchFolders = async () => {
      setIsLoaded(false);
      const folderGateway = new FetchFolderGateway();
      const fetchedFolders = await folderGateway.getFoldersByPreSignatureValidationState(currentPageNumber, ITEMS_PER_PAGE, term, formId);
      if (fetchedFolders.dossiers === null) {
        return;
      }

      setFolders(fetchedFolders.dossiers);
      setTotalItems(fetchedFolders.totalItems);
      setIsLoaded(true);
    };

    fetchFolders();
  }, [currentPageNumber, term, formId]);

  useEffect(() => {
    updateQueryParams({ currentPage: '1' });
  }, [term]);

  useEffect(() => {
    new FormGateway().getForms().then(forms => {
      if (null !== forms) {
        setForms(forms)
      }
    })
  }, [])

  const handleDeleteFolder = (id: string): void => {
    return
  };

  if (!isLoaded) {
    return <div className="flex-container">
      <div className="col-md-12">
        <Loader />
      </div>
    </div>
  }

  return (
    <div className="flex-container">
      <div className="col-md-12">
        <FoldersDataList
          folders={folders ?? []}
          forms={forms}
          handleDeleteFolder={handleDeleteFolder}
          state={null}
          totalItems={totalItems}
          itemsPerPage={ITEMS_PER_PAGE}
          type={'pre-signature-validation'}
          viewMode={viewMode}
          requestSort={requestSort}
          sortConfig={sortConfig}
        />
      </div>
    </div>
  );
};

export default PreSignatureValidationFoldersComponent;